export const funcaoOrganizar = (array) => {

  const groupedByCPF = array.reduce((acc, currentValue) => {
    if (!acc[currentValue.cpf]) {
      acc[currentValue.cpf] = [currentValue];
    } else {
      acc[currentValue.cpf].push(currentValue);
    }
    return acc;
  }, {});

  const merged = Object.values(groupedByCPF).map((group) => {
    const sortedGroup = group.sort((a, b) => new Date(b.dataEmissao) - new Date(a.dataEmissao));
    const [current, ...renovacoes] = sortedGroup;
    return {
      ...current,
      renovacoes
    };
  });

  return merged;
}

export const cpfMask = value => {
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export const codigoUsoMask = (value) => {
  value = value.replace(/\D/g, "");

  // Adiciona o hífen após os 4 primeiros dígitos
  if (value.length > 4) {
    value = value.replace(/^(\d{4})(\d)/, "$1-$2");
  }

  // Adiciona o ponto após os próximos 3 dígitos, após o hífen
  if (value.length > 7) {
    value = value.replace(/^(\d{4}-\d{3})(\d)/, "$1.$2");
  }

  // Limita a 3 dígitos após o ponto
  if (value.length > 10) {
    value = value.replace(/^(\d{4}-\d{3}\.\d{3})(\d{1,})$/, "$1");
  }

  return value;
};

export const organizarPorEstado = (arrayA, arrayB) => {
  // Filtrar gestores que têm estado válido (não null, undefined ou vazio)
  const gestoresComEstado = arrayB.filter((gestor) => gestor.estado && gestor.estado.trim() !== '');
  const gestoresSemEstado = arrayB.filter((gestor) => !gestor.estado || gestor.estado.trim() === '');

  // Organizar gestores com estado
  const estadosExistentes = gestoresComEstado.map((e) => e.estado);
  const guardandoEstados = arrayA.filter((a) => estadosExistentes.includes(a));
  const organizadosPorEstado = guardandoEstados.map((e) => ({
    [e]: gestoresComEstado.filter((x) => e === x.estado),
  }));

  // Adicionar gestores sem estado em uma seção "Sem Estado"
  if (gestoresSemEstado.length > 0) {
    organizadosPorEstado.push({
      "Sem Estado": gestoresSemEstado
    });
  }

  return organizadosPorEstado;
};


export const arrayEstados = [
'Acre',
'Alagoas',
'Amapá',
'Amazonas',
'Bahia',
'Ceará',
'Distrito Federal',
'Espirito Santo',
'Goiás',
'Maranhão',
'Mato Grosso do Sul',
'Mato Grosso',
'Minas Gerais',
'Pará',
'Paraíba',
'Paraná',
'Pernambuco',
'Piauí',
'Rio de Janeiro',
'Rio Grande do Norte',
'Rio Grande do Sul',
'Rondônia',
'Roraima',
'Santa Catarina',
'São Paulo',
'Sergipe',
'Tocantins',
]


export function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
